import React, { useEffect, useMemo, useState } from "react";
import styled, { css } from "styled-components";
import { ProductStars } from "./ProductStars";
import { Stars } from "./Stars";
import { ReviewForm } from "./ReviewForm";
import { reviews } from "../utils/productHelpers";
import randomstring from "randomstring";

const ReviewsStyles = styled.div`
  ${({ ...props }) => css`
    ul {
      margin-top: ${props.$displayProductStars ? '24px' : '0'};
    }
    .review_form {
      scroll-margin-top: 150px;
    }
    @media (min-width: ${props.theme.breakpoints.md}) {
      ul {
        margin-top: ${props.$displayProductStars ? '48px' : '0'};
      }
    }
  `}
`;

const ReviewStyles = styled.div`
  ${({ ...props }) => css`
    margin-bottom: 24px;

    h3 {
      margin-bottom: 8px;
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      max-width: 70%;
      margin-bottom: 48px;
    }
  `}
`;

const StarsStyles = styled.div`
  ${({ ...props }) => css`
    @media (min-width: ${props.theme.breakpoints.md}) {
      margin: 16px 0;
    }
  `}
`;

const ReviewFooterStyles = styled.div`
  ${({ ...props }) => css`
    display: flex;
    margin-top: 16px;
    font-size: .75rem;

    strong {
      margin-right: 16px;
    }
  `}
`;

export const ProductReviews = ({
  productId,
  name,
  source,
  displayProductStars = true,
  isGreyBg,
  outOf = false,
}) => {
  const rand = useMemo(() => randomstring.generate(5), []);

  const [reviewFormVisibleState, setReviewFormVisibleState] = useState(false)

  function handleOpenReviewForm() {
    setReviewFormVisibleState(
      (reviewFormVisibleState) => !reviewFormVisibleState
    )
  }

  useEffect(() => {
    if (reviewFormVisibleState) {
      document.querySelector(`.${rand}-review_form`).scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [reviewFormVisibleState, rand]);

  const currentReviews = reviews(productId)
  
  return (
    <ReviewsStyles $displayProductStars={displayProductStars}>
      {displayProductStars && <ProductStars productId={productId} outOf={outOf} />}
      <ul>
        {currentReviews.length > 0 &&
          currentReviews.map((reviewItem) => {
            const review = reviewItem.node.customerReviews;
            return (
              <ReviewStyles key={`${randomstring.generate(5)}_${reviewItem.node.title}`}>
                <StarsStyles>
                  <Stars aR={review.reviewRating} small />
                </StarsStyles>
                <h3>{reviewItem.node.title}</h3>
                <p>{review.reviewText}</p>
                <ReviewFooterStyles>
                  <strong>{review.reviewSource}</strong>
                  <span>{review.reviewDate}</span>
                </ReviewFooterStyles>
              </ReviewStyles>
            );
          })}
      </ul>
      <button onClick={handleOpenReviewForm}>Write a review</button>
      {reviewFormVisibleState && (
        <div className={`${rand}-review_form review_form`}>
          <ReviewForm source={source} productId={productId} productName={name} isGreyBg={isGreyBg} />
        </div>
      )}
    </ReviewsStyles>
  );
};
